/** Copyright (c) 2019 T. Rowe Price. All rights reserved. */

import './SubscriptionsRowLabel.scss';

import { node, string } from 'prop-types';
import React from 'react';

import { ReactComponent as QuestionCircle } from 'assets/icons/question-circle.svg';
import BaseModal from 'components/shared/Modal/BaseModal';
import Disclosure from 'components/shared/Disclosure/Disclosure';
import { contentConverter } from 'services/Content';

class SubscriptionsRowLabel extends React.Component {
  state = {
    showModal: false
  };

  showModal = () => this.setState({ showModal: true });

  hideModal = () => this.setState({ showModal: false });

  render() {
    const {
      children,
      label,
      modalContent,
      isInvestorMag,
      investorMagModalTitle,
      labelClassname
    } = this.props;
    const { showModal } = this.state;
    const labelClass = `label-modal-wrapper ${labelClassname}`;

    return (
      <div className="subscriptions-row-label">
        {showModal && (
          <BaseModal
            close={this.hideModal}
            containerClassName="subscriptions-information-modal"
            hideAnchor={true}
            isOpen={true}
            title={isInvestorMag ? investorMagModalTitle : label}
            isInvestorMag={isInvestorMag}>
            <Disclosure content={modalContent} />
          </BaseModal>
        )}
        <div className={labelClass}>
          {isInvestorMag ? (
            <div
              dangerouslySetInnerHTML={{
                __html: contentConverter.makeHtml(label)
              }}
            />
          ) : (
            label
          )}
          {modalContent && (
            <QuestionCircle
              className="information-modal-icon"
              onClick={this.showModal}
            />
          )}
        </div>
        {children}
      </div>
    );
  }
}

SubscriptionsRowLabel.propTypes = {
  children: node,
  label: string.isRequired,
  modalContent: string
};

export default SubscriptionsRowLabel;
